// extracted by mini-css-extract-plugin
export default {"container":"Kp-z","heading":"Lp-z","text":"Mp-z","info":"Np-z","link":"Op-z","fullMaxWidth":"Pp-z"};